import whereami from '../utils/whereami';
var nativePush = function (url) {
    window.location.href = url.startsWith('/') || url.startsWith('http') ? url : "/".concat(url);
};
var nativeReplace = function (url) {
    window.location.replace(url.startsWith('/') || url.startsWith('http') ? url : "/".concat(url));
};
var nativeReload = function () {
    window.location.reload();
};
var nativeBack = function () {
    window.history.back();
};
export var useNativeRouter = function (ctx) {
    var _a, _b, _c, _d, _e;
    var host = "".concat((_a = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _a === void 0 ? void 0 : _a.method, "://").concat((_c = (_b = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _b === void 0 ? void 0 : _b.headers) === null || _c === void 0 ? void 0 : _c.host);
    var url = (((_d = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _d === void 0 ? void 0 : _d.url) && new URL(ctx.req.url, host)) ||
        (whereami.isClientSide && window.location) ||
        {};
    return {
        query: ((_e = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _e === void 0 ? void 0 : _e.query) ||
            (whereami.isClientSide &&
                Object.fromEntries(new URLSearchParams(window.location.search))) ||
            {},
        push: nativePush,
        back: nativeBack,
        // TODO: create the native methods below
        beforePopState: function () { },
        events: {},
        replace: nativeReplace,
        reload: nativeReload,
        pathname: url === null || url === void 0 ? void 0 : url.pathname,
        isReady: true,
    };
};
//# sourceMappingURL=useNativeRouter.js.map